import React from 'react';
import { Row, Col } from '../../components/grid';
import { Heading3, Paragraph, Span } from '../../components/typography';
import { Item } from '../commerce';
import { FadoelAlternativeView2 } from '../../components/commerce/Item';
import fadoelTypes from '../../content/commerce/fadoelTypes';
import getFadoelAlias from '../../content/commerce/fadoelAliases';
import FadoelTypeLinks from './FadoelTypeLinks';

/* eslint react/prefer-stateless-function: 0 */
export default class FadoelTypeView extends React.Component {
  render() {
    const { type } = this.props;
    const typeAlias = getFadoelAlias(type);
    const {
      greyLight,
      content,
      headline,
      items,
      allItemsDescription,
    } = {
      ...fadoelTypes[typeAlias],
      ...this.props,
    };
    return (
      <Row>
        <Col xs={12} lg={5} paddingBottom="0">
          <Heading3>{headline}</Heading3>
          {content}
        </Col>
        <Col xs={12} lg={7} paddingBottom="0">
          <Row>
            <Col xs={12} sm={6} paddingTop="0" paddingBottom="0">
              <Item
                varenr={items[0]}
                display={FadoelAlternativeView2}
                singleWidth={['50px']}
                whiteBg={!greyLight}
              />
            </Col>
            <Col xs={12} sm={6} paddingTop="0" paddingBottom="0">
              <Item
                varenr={items[1]}
                display={FadoelAlternativeView2}
                singleWidth={['50px']}
                whiteBg={!greyLight}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={12} paddingTop="0">
          <Paragraph>
            {allItemsDescription}<br />
            <Span fontSize="12px">Links fører til produktsider med mere information</Span>
          </Paragraph>
          <FadoelTypeLinks type={type} />
        </Col>
      </Row>
    );
  }
}
